/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-12-07 16:59:41
 * @LastEditTime: 2021-12-28 18:40:09
 * @FilePath: /teacher-h5/src/service/base.js
 */
import axios from 'axios'
import httpStatus from './httpstatus'
import storage from '@/utils/storage.js'
import router from '../router'
import { removeToken } from '@/utils/tools.js'
import { message } from 'ant-design-vue'

const ERROR_CODE = {
  1001: '用户名不存在',
  1002: '密码错误',
  1003: '已在其他端登录',
  1004: '用户未绑定业务系统',
  1005: '已经达到同时可以登陆最大数量',
  1006: 'TOKEN 已经过期',
  1007: 'TOKEN 不存在',
  1008: '短信验证码错误',
  1009: 'TOKEN 解析失败',
  1010: '服务异常',
  1011: '未知错误',
  1012: '参数错误',
  1013: 'Token失效',
  1014: '刷新TOKEN 失效'
}
// 99999 无小括狐教师端权限
const LOGOUT_CODE = [1003, 1006, 1007, 1009, 1012, 1013, 1014, 99999]

/**
 * 基础请求服务
 */
const _Axios = axios.create({
  baseURL: '',
  timeout: 50000
  // headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})

// 请求拦截器
_Axios.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

// 响应拦截器即异常处理
_Axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      const { config } = res
      const status = res.data && res.data.status
      const { body, errorCode, errorMessage } = res.data
      const { hideErrMsg } = config.headers

      if (status !== 1) {
        if (LOGOUT_CODE.indexOf(errorCode) !== -1) {
          !hideErrMsg && message.error(errorMessage || ERROR_CODE[errorCode] || '您未登陆或登陆状态已经失效')

          storage.remove('ptxkhtpc')
          removeToken()
          setTimeout(() => {
            router.replace({
              name: 'login'
            })
          }, 1000)
        } else {
          console.log('-----------')
          !hideErrMsg && message.error(errorMessage || ERROR_CODE[errorCode] || '抱歉，系统出现错误，请稍后重试')
        }

        return Promise.reject(res.data)
      }

      return Promise.resolve(body)
    }
  },
  error => {
    console.log('error', error)
    if (error && error.response) {
      const { errorMessage, status } = error.response
      // 错误信息先走接口返回，在走默认信息
      const errMessage = errorMessage || httpStatus[status]

      message.error(errMessage || '服务器异常')
    } else {
      message.error('连接到服务器失败')
    }
    return Promise.reject(error.response)
  }
)

export default _Axios
